import {useMemo} from 'react';

import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {buildDomainIncidentsFilters} from 'features/domain/lib/domainIncidentsScreen';
import {
    DOMAIN_INCIDENTS_ORDER_FIELDS,
    getDomainIncidentFilterArray,
    getDomainIncidentFilters,
} from 'features/domain/lib/domainFilters';
import {useHasTariffLimit, usePlugState} from 'entities/user';
import useCanCreateDomainMonitor from 'features/domain/model/useCanCreateDomainMonitor';
import {useCreateGate} from 'entities/tariff';
import {objectToArray} from 'shared/lib/filterHelper';
import useListParams from 'shared/lib/hooks/useListParams';
import useResetPageOnEmpty from 'shared/lib/hooks/useResetPageOnEmpty';
import {getPollingInterval} from 'shared/api/pollingHelper';

export const useDomainIncidentsScreen = () => {
    const {args, sort, setSort, searchParams, hasFilters} = useListParams({
        getFilters: getDomainIncidentFilterArray,
        sortFields: DOMAIN_INCIDENTS_ORDER_FIELDS,
    });
    const hasAccess = useHasTariffLimit('domain_monitor_max_count_limit');
    const {open, close, isCreateOpen, isExceededOpen} = useCreateGate(useCanCreateDomainMonitor());

    const queryArgs = useMemo(() => ({
        ...args,
        filters: objectToArray(buildDomainIncidentsFilters(getDomainIncidentFilters(searchParams))),
    }), [args, searchParams]);

    const {data, isLoading, isFetching, refetch} = domainIncidentAPI.useGetDomainIncidentsAllQuery(queryArgs, {
        skip: !hasAccess,
        pollingInterval: getPollingInterval(),
    });

    const isRedirecting = useResetPageOnEmpty(data);

    const plugState = usePlugState({
        tariffField: 'domain_monitor_max_count_limit',
        isLoading: isLoading || isRedirecting,
        isEmpty: data?.items?.length === 0 && data?.totalItems === 0,
        hasFilters,
    });

    return {
        data,
        isLoading,
        isFetching,
        refetch,
        sort,
        setSort,
        plugState,
        openCreate: open,
        closeCreate: close,
        isCreateOpen,
        isExceededOpen,
    };
};

export default useDomainIncidentsScreen;
